// extracted by mini-css-extract-plugin
export default {"container":"Description_container_RZTWy","title":"Description_title_J2YTt","text":"Description_text_g7m4u"};